import { render, staticRenderFns } from "./PolicyCreateModal.vue?vue&type=template&id=cd15ea50&scoped=true"
import script from "./PolicyCreateModal.vue?vue&type=script&lang=js"
export * from "./PolicyCreateModal.vue?vue&type=script&lang=js"
import style0 from "./PolicyCreateModal.vue?vue&type=style&index=0&id=cd15ea50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd15ea50",
  null
  
)

export default component.exports